<template>
  <div class="badge" @click.stop>
    <div class="badge__container" :id="triggerId">
      <Icon :name="icon" size="xs" class="badge__icon" />
      <span class="badge__text" v-html="text"></span>
    </div>
    <Dropdown
      v-if="triggerId && tooltip"
      :triggerId="triggerId"
      placement="top"
      listeners="click hover"
      hide-overlay
      auto-width
    >
      <template slot="items">
        <div class="base-dropdown__item">
          <div class="base-dropdown__text">
            <span v-html="tooltip"></span>
          </div>
        </div>
      </template>
    </Dropdown>
  </div>
</template>


<script lang="js">
import Dropdown from '@/components/dropdown/dropdown.vue';

export default {
  name: 'Badge',
  props: {
    icon: String,
    text: String,
    tooltip: String,
  },
  components: { Dropdown },

  data() {
    return {
      triggerId: `videoDetails_${Math.random().toString().replace('.', '')}`,
    };
  }
};
</script>


<style lang="scss" scoped>
  @import "./badge";
</style>